export const API_URL = process.env.REACT_APP_SERVER_URL
export const ECOLOGI_URL = 'https://public.ecologi.com'
